import React from "react";

/**
 * Радио DS (canon-session 2026-07-24): круглый бокс, checked = accent-точка.
 */
export function Radio({
  checked = false,
  onChange,
  label,
  disabled = false,
}: {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: React.ReactNode;
  disabled?: boolean;
}) {
  return (
    <label
      className={`inline-flex items-center gap-2.5 text-sm text-text-primary ${
        disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
      }`}
    >
      <span
        onClick={() => !disabled && onChange?.(true)}
        className={`w-5 h-5 rounded-full inline-flex items-center justify-center border ${
          checked ? "border-accent" : "border-border"
        }`}
      >
        {checked && <span className="w-2.5 h-2.5 rounded-full bg-accent" />}
      </span>
      {label}
    </label>
  );
}
